module.exports = __webpack_public_path__ + "static/img/2012-B.f66f135.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2012-B.png
// module id = 4Euw
// module chunks = 1